import { COMPOSE_ONLY_FLUID_KEEP_BODY } from '../utils/constants';

export function cleanUpFluidInEditor(fluidEntity: HTMLElement) {
    const keepBodyNodes = fluidEntity.querySelectorAll(`.${COMPOSE_ONLY_FLUID_KEEP_BODY}`);
    for (let i = keepBodyNodes.length - 1; i >= 0; i--) {
        fluidEntity.parentNode?.insertBefore(keepBodyNodes[i], fluidEntity.nextSibling);
    }

    fluidEntity.parentNode?.removeChild(fluidEntity);
}
